import React, {Fragment, useEffect, useState} from "react";
import Box from "../../lib/appfuse-react/component/Box";
import {
    Checkbox,
    Dialog,
    DialogContent,
    FormControlLabel,
    FormGroup,
    Grid, InputAdornment,
    Typography
} from "@material-ui/core";
import i18n from "../../lib/appfuse-react/core/i18n";
import Form from "../../lib/appfuse-react/component/Form";
import Address, {MobileAddress} from "../Address";
import SelectField from "../../lib/appfuse-react/component/SelectField";
import FileField from "../../lib/appfuse-react/component/FileField";
import ContactPerson, {MobileContactPerson} from "../Member/ContactPerson";
import Space from "../../lib/appfuse-react/component/Space";
import BillInfo from "../Member/BillInfo";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import lang from "../../lib/appfuse-react/core/lang";
import time from "../../lib/appfuse-react/core/time";
import valueChange from "../Judge/ValueChange";
import code from "../../lib/appfuse-react/core/code";
import Toolbar from "../Toolbar";
import Expander from "../../lib/appfuse-react/component/Expander";
import RichText from "../../lib/appfuse-react/component/RichText";
import organizationService from "../../service/organization/organizationService";
import TypographyWithLink from "../TypographyWithLink";
import TextField from "../../lib/appfuse-react/component/TextField";
import IconButton from "@material-ui/core/IconButton";
import {Close as CloseIcon, Star as StarIcon, Visibility, VisibilityOff} from "@material-ui/icons";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";

export function RegistrationInformationContent(props) {
    const {course={}, value={}, change={}, title=true, readOnly, isQuery} = props;
    const {cost, location, courseTitleCode} = course;
    const {email} = lang.isEmpty(value)? change:value;
    const [courseFeeOpen, setCourseFeeOpen] = useState(false);
    const [idNoShow, setIdNoShow] = useState(false);

    const getClassDate = () => {
        const {courseDateStart, courseDateEnd} = course;
        if(courseDateStart && courseDateEnd) {
            return `${time.format(courseDateStart, 'YYYY/MM/DD')} ~ ${time.format(courseDateEnd, 'YYYY/MM/DD')}`;
        } else {
            return '';
        }
    };
    const classDate = getClassDate();

    const readOnlyData = { cost, classDate, location, email };

    const applyCreditOption = code.get('applyCredit');
    let applyCredit;
    if(['MM', 'MH', 'MG', 'POCT'].includes(courseTitleCode)) applyCredit = applyCreditOption.filter(item => item.value!=='government');
    else applyCredit = applyCreditOption.filter(item => item.value!=='medical');

    const category17025CertificateNo = ['TH', 'CH', 'LG'];
    const category15189CertificateNo = ['MH', 'MG'];
    const categoryMemberOfSigningMemorandum = ['MM', 'MH', 'MG', 'TL', 'CU', 'POCT'];

    const courseFeeStatement = [
        'In line with the "Promotion Method - Case C" of the Association: (Please refer to the ',
        {
            text: 'Course Fee',
            onClick: () => { setCourseFeeOpen(true); }
        },
        ' discount method)'
    ];

    const variant = readOnly? 'standard':'outlined';


    const responsive = useResponsive();
    const isMobile = responsive.isSmallScreen();
    const xsThree = isMobile? 12:3;
    const xsSix = isMobile? 12:6;

    const CombineAddress = isMobile? MobileAddress:Address;

    return (
        <Box fullWidth overflow='auto' paddingY={1}>
            {
                title && (
                    <Box fullWidth>
                        <Typography variant='h6'>{i18n.translate('Registration Information')}</Typography>
                    </Box>
                )
            }
            <Form value={readOnlyData} readOnly paddingTop={2} paddingBottom={readOnly? 2:4}>
                <Grid container spacing={2} item xs={12}>
                    {
                        !isQuery && (
                            <Grid item xs={xsThree}>
                                {/*課程費用*/}
                                <TextField name='cost' label='Cost' fullWidth/>
                            </Grid>
                        )
                    }
                    {/*課程日期*/}
                    <Grid item xs={xsThree}>
                        <TextField name='classDate' label='Class Date' fullWidth/>
                    </Grid>
                    {/*課程地點*/}
                    <Grid item xs={xsThree}>
                        <SelectField name='location' label='Class Location' code='classLocation' fullWidth/>
                    </Grid>
                    {/*電子郵件*/}
                    <Grid item xs={xsThree}>
                        <TextField name='email' label='Email' fullWidth/>
                    </Grid>
                </Grid>
            </Form>
            <Grid container spacing={2} item xs={12}>
                <Grid item xs={12}>
                    <Form value={value} change={change} onChange={props.onChange} readOnly={readOnly}>
                        <Grid container spacing={2}>
                            {/*姓名(中文)*/}
                            <Grid item xs={xsThree}>
                                <TextField name='chineseName' label='Chinese Name' variant={variant} fullWidth helperText='書寫範例：王小華' required disabled/>
                            </Grid>
                            {/*姓名(英文)*/}
                            <Grid item xs={xsThree}>
                                <TextField name='englishName' label='English Name' variant={variant} fullWidth helperText='書寫範例：Ciao-Hua Wang' required disabled/>
                            </Grid>
                            {/*手機*/}
                            <Grid item xs={xsThree}>
                                <TextField name='mobilePhone' label='Mobile Phone' variant={variant} fullWidth required/>
                            </Grid>
                            {/*電話*/}
                            <Grid item xs={xsThree}>
                                <TextField name='phone' label='Phone' variant={variant} required fullWidth helperText='Please fill in the company phone number first'/>
                            </Grid>

                            {/*通訊地址*/}
                            <Grid item xs={12}>
                                <CombineAddress name='mailingAddress' subtitle='Mailing Address' variant={variant} fullWidth withoutCountry required/>
                            </Grid>

                            {/*申請學分*/}
                            <Grid item xs={xsThree}>
                                <SelectField name='applyCredit' label='Apply Credit' variant={variant} fullWidth options={applyCredit} required/>
                            </Grid>
                            {
                                valueChange.isNotEqual(value.applyCredit, change.applyCredit, 'notNeeded') &&
                                valueChange.isNotEqual(value.applyCredit, change.applyCredit, null) && (
                                    <Grid item xs={xsThree}>
                                        {/*身分證字號*/}
                                        <TextField name='idNo' label='Id No' variant={variant} fullWidth helperText='學分查詢完成後即會消除' required
                                                   type={idNoShow? "text": "password"}
                                                   InputProps={{
                                                       endAdornment: (
                                                           <InputAdornment position='end'>
                                                               <IconButton onClick={() => setIdNoShow(!idNoShow)}>
                                                                   {idNoShow ? <Visibility/> : <VisibilityOff/>}
                                                               </IconButton>
                                                           </InputAdornment>)
                                                   }}
                                        />
                                    </Grid>
                                )
                            }
                            {/*本會認可實驗室*/}
                            <Grid item xs={xsThree}>
                                <SelectField name='ourAccreditedLaboratory' label='Accredited Laboratory' variant={variant} fullWidth code='whether' required/>
                            </Grid>
                            {
                                valueChange.isEqual(value.ourAccreditedLaboratory, change.ourAccreditedLaboratory, 'Y') && (
                                    <Grid item xs={xsThree}>
                                        {/*實驗室編號*/}
                                        <TextField name='laboratoryNo' label='Laboratory No' variant={variant} fullWidth required/>
                                    </Grid>
                                )
                            }
                        </Grid>
                    </Form>
                </Grid>

                <Grid item xs={12}>
                    <Form value={value} change={change} onChange={props.onChange} readOnly={readOnly}>
                        <Grid container spacing={2}>
                            {/*產業別*/}
                            <Grid item xs={xsThree}>
                                <SelectField name='industry' label='Industry' variant={variant} fullWidth code='industry' required/>
                            </Grid>
                            {/*領域別*/}
                            <Grid item xs={xsThree}>
                                <SelectField name='field' label='Field' variant={variant} fullWidth code='field' required/>
                            </Grid>
                            {
                                category17025CertificateNo.includes(courseTitleCode) && (
                                    <Grid item xs={xsSix}>
                                        {/*參加本會ISO17025訓練證書編號*/}
                                        <TextField name='certificateNo17025' label='ISO17025 Certificate No' variant={variant} fullWidth required/>
                                    </Grid>
                                )
                            }
                            {
                                category15189CertificateNo.includes(courseTitleCode) && (
                                    <Grid item xs={xsSix}>
                                        {/*參加本會ISO 15189訓練合格證書編號*/}
                                        <TextField name='certificateNo17025' label='ISO15189 Certificate No' variant={variant} fullWidth required/>
                                    </Grid>
                                )
                            }
                        </Grid>
                    </Form>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {
                             categoryMemberOfSigningMemorandum.includes(courseTitleCode) && (
                                <Fragment>
                                    {/*為本會簽署備忘錄機構的學員或職員*/}
                                    <Grid item xs={12}>
                                        <Form value={value} change={change} onChange={props.onChange} readOnly={readOnly}>
                                            <SelectField name='memberOfSignedMemorandum' code={'whether'} variant={'outlined'} label='Member Of Signing Memorandum' required/>
                                        </Form>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box fullWidth fullHeight display='flex' justifyContent='flex-start' gap={4}>
                                            {
                                                !isQuery && valueChange.isEqual(value.memberOfSignedMemorandum, change.memberOfSignedMemorandum, "Y") && (
                                                    <Box fullHeight display='flex' alignItems='center' gap={1}>
                                                        <Box paddingTop={1}>
                                                            <StarIcon fontSize='small' color='secondary'/>
                                                        </Box>
                                                        <TypographyWithLink data={courseFeeStatement} color='secondary'/>
                                                    </Box>
                                                )
                                            }
                                        </Box>
                                    </Grid>
                                    {
                                        valueChange.isEqual(value.memberOfSignedMemorandum, change.memberOfSignedMemorandum, "Y") && (
                                            <Fragment>
                                                {/*與本會簽署備忘錄機構*/}
                                                <Grid item xs={xsSix}>
                                                    <Form value={value} change={change} onChange={props.onChange} readOnly={readOnly}>
                                                        <SelectField name='signingMemorandum' label='Signing Memorandum' variant={variant} fullWidth code='signingMemorandum' required/>
                                                    </Form>
                                                </Grid>
                                                {/*與本會簽署備忘錄機構證明文件*/}
                                                <Grid item xs={xsSix}>
                                                    <Form value={value} change={change} onChange={props.onChange}>
                                                        <FileField name='certifiedDocument' label='Certification Documents Of Signing Memorandum' helperText="Please upload the proof of the current year, such as: Medical Laboratory Science Association membership certificate" variant={variant} fullWidth fullHeight required readOnly={readOnly}/>
                                                    </Form>
                                                </Grid>
                                            </Fragment>
                                        )
                                    }
                                </Fragment>
                            )
                        }
                        {/*備註*/}
                        <Grid item xs={12}>
                            <Form value={value} change={change} onChange={props.onChange} readOnly={readOnly}>
                                <TextField name='remark' label='Remark' variant={variant} fullWidth multiline/>
                            </Form>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            { courseFeeOpen && <CourseFee open={courseFeeOpen} onClose={ () => { setCourseFeeOpen(false); } }/> }
        </Box>
    );
}

function CourseFee(props) {
    const {open} = props;
    const [value, setValue] = useState(null);

    useEffect(() => {
        (async () => {
            const value = await organizationService.get();
            setValue(value.discountDescription);
        })();
    }, []);

    return (
        <Dialog open={open} maxWidth='md' fullWidth>
            <Toolbar>
                <Space spacing={1}/>
                <Typography variant='h6'>{i18n.translate('Course Fee - Discount Method')}</Typography>
                <Expander/>
                <IconButton onClick={props.onClose}><CloseIcon /></IconButton>
            </Toolbar>
            <DialogContent dividers>
                <RichText value={value} fullWidth overflow='visible'/>
            </DialogContent>
        </Dialog>
    );
}

export function ContactPersonAndInvoiceInformationContent(props) {
    const {value={}, change={}, readOnly} = props;

    const handleSameAsStudentInformation = ({change:innerChange}) => {
        const newChange = {...change, ...innerChange};
        const newValue = {...value, ...innerChange};

        const {sameAsStudentInformation} = innerChange;
        if(lang.isNotUndefined(sameAsStudentInformation)) {
            if(sameAsStudentInformation && sameAsStudentInformation!==change.sameAsStudentInformation) {
                newChange.contactPerson = valueChange.getEffectiveValue(value.chineseName, change.chineseName);
                newChange.contactEmail = valueChange.getEffectiveValue(value.email, change.email);
                newChange.contactMobilePhone = valueChange.getEffectiveValue(value.mobilePhone, change.mobilePhone);
                newValue.contactPerson = newChange.contactPerson;
                newValue.contactEmail = newChange.contactEmail;
                newValue.contactMobilePhone = newChange.contactMobilePhone;
            }
        }

        props.onChange(new UserEvent({value:newValue, change:newChange}));
    };

    const responsive = useResponsive();
    const isMobile = responsive.isSmallScreen();
    const CombineContactPerson = isMobile? MobileContactPerson:ContactPerson;

    const [courseFeeOpen, setCourseFeeOpen] = useState(false);

    const courseFeeStatement = [
        '注意三：',
        'Please refer to the ',
        {
            text: 'Course Fee',
            variant: 'body2',
            onClick: () => { setCourseFeeOpen(true); }
        },
        ' discount method'
    ];

    return (
        <Box fullWidth overflow='auto' paddingY={1}>
            {/*聯絡人*/}
            <Box fullWidth paddingBottom={1}>
                <Typography variant='h6'>{i18n.translate('Contact Person')}</Typography>
            </Box>
            {
                !readOnly && (
                    <Form value={value} change={change} onChange={handleSameAsStudentInformation} readOnly={readOnly}>
                        {/*同學員資料*/}
                        <FormGroup row>
                            <FormControlLabel name='sameAsStudentInformation' control={<Checkbox />} label='Same as student information' />
                        </FormGroup>
                    </Form>
                )
            }
            <CombineContactPerson value={value} change={change} onChange={props.onChange} readOnly={readOnly} required enrollment/>

            <Space spacing={8} vertical />


            {/*發票資料*/}
            <Box fullWidth paddingY={2}>
                <Typography variant='h6'>{i18n.translate('Invoice Information')}</Typography>
                <Box display={'flex'}>
                    <Typography variant='body2'>{i18n.translate('注意一：符合甲案三人同行優惠者，需於課前一個月統一提出名單。')}</Typography>
                    <Typography variant='body2' color='secondary'>{i18n.translate('(自2025年7月份課程起實施)')}</Typography>
                </Box>
                <Typography variant='body2'>{i18n.translate('注意二：請務必完整填寫發票資訊，若因資訊填寫不完整導致無折扣優惠者，本會恕無法受理退費申請。')}</Typography>
                <TypographyWithLink variant='body2' data={courseFeeStatement}/>
            </Box>
            <BillInfo value={value} change={change} onChange={props.onChange} readOnly={readOnly} required/>
            { courseFeeOpen && <CourseFee open={courseFeeOpen} onClose={ () => { setCourseFeeOpen(false); } }/> }
        </Box>
    );
}